<script lang="ts">
	import Card from '@smui/card';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import ConfirmModal from '../../../../shared/components/common/Modal/ConfirmModal.svelte';
	import { resetPageIfFiltersChanged } from '../../../../shared/functions';
	import Area from '../../../../shared/models/Area/Area';
	import FiltroGenerico from '../../../../shared/models/Filtri/FiltroGenerico';
	import TableLoading from './../../../..//shared/components/common/Loading/TableLoading.svelte';
	import Pagination from './../../../..//shared/components/common/Table/Pagination.svelte';

	let filters: FiltroGenerico = {
		nomeComune: '',
		pagina: 1,
		elementiPerPagina: 10,
	};

	$: [data, loading, error] = Area.getList(filters);

	let [dataEliminazione, loadingEliminazione, errorEliminazione] = [null, null, null];
	let openConfirmDeleteDialog: boolean = false;
	let areaToDelete: Area = null;

	async function onDelete(id) {
		[dataEliminazione, loadingEliminazione, errorEliminazione] = await Area.delete(id);
		if (!$errorEliminazione) {
			[data, loading, error] = Area.getList(filters);
		}
	}

	let prevFilters = {};

	$: {
		const newPage = resetPageIfFiltersChanged(prevFilters, filters);
		if (newPage !== null) {
			filters.pagina = newPage;
		}
		prevFilters = { ...filters };
	}
</script>

<ConfirmModal 
    content="<p class='font-bold'>Sei sicuro di voler completare l'operazione?</p>
            <p class='text-sm'>Confermando, procederai con l'eliminazione dell'area <span class='font-semibold'>{areaToDelete?.nomeComune}</span>.</p>
            <p class='text-sm'>Questa azione è irreversibile e comporterà la rimozione di tutti i dati e le configurazioni ad essa associati.</p>"
    bind:showModal="{openConfirmDeleteDialog}" 
    onConfirm="{() => onDelete(areaToDelete?.id)}" 
/>
<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.areas.list.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			<a href="/#/area/0">
				<button class="btn-white h-14 w-14 sm:h-16 sm:w-16">
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">add</span>
				</button>
			</a>
		</div>
	</div>
	<div class="md:grid-cols-2 lg:grid-cols-3 grid grid-cols-1 gap-8 p-4">
		<Input label="{$_('page.areas.list.city_name')}" bind:value="{filters.nomeComune}" />
	</div>
	{#if $loading}
		<TableLoading />
	{:else if $data?.response}
		<div class="flex flex-col">
			<div class="sm:-mx-6 lg:-mx-8 -my-2 overflow-x-auto">
				<div class="sm:px-6 lg:px-8 inline-block min-w-full py-2 align-middle">
					<div class="overflow-hidden">
						<table class="min-w-full p-0 m-0 text-sm leading-10 border-t-4 border-collapse border-black table-auto">
							<thead>
								<tr class="p-1">
									<th scope="col" class="border-b p-2.5 text-center text-xs leading-6 tracking-wider"
										>{$_('page.areas.list.city_name')}</th
									>
									<th scope="col" class="relative border-b p-2.5 text-center text-xs leading-6 tracking-wider"
										>{$_('global.actions')}</th
									>
								</tr>
							</thead>
							<tbody>
								{#each $data.response as row}
									<tr class="odd:bg-white even:bg-gray-50 p-1">
										<td class="border-b p-2.5 text-center leading-5">{row.nomeComune ?? ''}</td>
										<td class="whitespace-nowrap border-b p-2.5 text-center leading-5">
											<div class="item-center flex justify-center">
												<div>
													<a href="/#/area/{row.id}">
														<button class="h-7.5 w-7.5">
															<span class="material-icons-outlined text-base leading-[1.8rem]">launch</span>
														</button>
													</a>
												</div>
												<div class="ml-4 h-7.5 w-7.5">
													<button
														on:click="{() => {
															areaToDelete = row;
															openConfirmDeleteDialog = true;
														}}"
														class="h-7.5 w-7.5"
													>
														<span class="material-icons-outlined text-base leading-[1.8rem]">delete</span>
													</button>
												</div>
											</div>
										</td>
									</tr>
								{/each}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="right-0">
			<Pagination bind:current="{filters.pagina}" bind:num_pages="{$data.totalPages}" bind:per_page="{filters.elementiPerPagina}" />
		</div>
	{/if}
</Card>
